import * as TK from 'components/post/PostFeedReactions/translations/constants';
import { Translations } from 'translations/types';

export const postFeedReactionsEnUsLocale: Translations = {
  [TK.POST_FEED_REACTIONS_REACTION]: 'reaction',
};
